import { render } from "./CalculaterPage.vue?vue&type=template&id=db912cea&scoped=true"
import script from "./CalculaterPage.vue?vue&type=script&lang=js"
export * from "./CalculaterPage.vue?vue&type=script&lang=js"

import "./CalculaterPage.vue?vue&type=style&index=0&id=db912cea&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db912cea"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QForm,QInput,QSelect,QRadio,QTable,QSpace,QTr,QTd,QBtn});
